// import 'lazysizes';
import objectFitImages from 'object-fit-images';
import animate from 'animate-vanilla-js';

import inView from './in-view';
import { initPage } from './init';
import './domains';
import './menu';
import './site-nav';
import './site-mega-menu';
import './video';
import './filter';
import './slider';
import './dialog';
import './google-maps';
import './map';
import './drop-down';
import './tags';
import './list-info-panel';
import './digital-scrolling-text';
import './scrolling-services';
import './digital-hero';
import './count-up';

objectFitImages();

document.addEventListener('DOMContentLoaded', () => {
  /**
   * Initialize aria visibility toggles.
   *
   * Usage:
   *    <button aria-expanded="false" aria-controls="myDropdown">Toggle</button>
   *    <div id="myDropdown" aria-hidden="true">Dropdown</div>
   */
  document.querySelectorAll('[aria-expanded][aria-controls]').forEach((el) => {
    el.addEventListener('click', (e) => {
      const id = el.getAttribute('aria-controls');
      const controlled = document.getElementById(id);
      const open = controlled.getAttribute('aria-hidden') !== 'false';

      controlled.setAttribute('aria-hidden', open ? 'false' : 'true');

      document.querySelectorAll(`[aria-controls="${id}"]`).forEach((el) => {
        el.setAttribute('aria-expanded', open ? 'true' : 'false');
      });

      e.preventDefault();
    });
  });

  // Expand & contract details & summary items
  const expanderItems = document.querySelectorAll('.js-expander-item');

  if (expanderItems) {
    expanderItems.forEach((item) => {
      const toggle = item.querySelector('.js-expander-item-toggle');
      const dropdownWrapper = item.querySelector('.dropdown-wrapper');
      const durationVar = getComputedStyle(item, null).getPropertyValue(
        '--expander-duration'
      );
      const duration = durationVar ? durationVar.slice(0, -2) : 150;

      toggle.addEventListener('click', function (event) {
        // first a guard clause: don't do anything
        // if we're already in the middle of closing the menu.
        if (item.classList.contains('item-closing')) {
          return;
        }
        // but, if the menu is open ...
        if (item.open) {
          // prevent default to avoid immediate removal of "open" attribute
          event.preventDefault();
          // add a CSS class that contains the animating-out code
          item.classList.add('item-closing');

          animate(
            dropdownWrapper.clientHeight,
            0,
            duration,
            'easeInOutQuad',
            (value) => {
              dropdownWrapper.style.height = `${value}px`;
            }
          ).then(() => {
            dropdownWrapper.style.cssText = '';
            item.removeAttribute('open');
            item.classList.remove('item-closing');
          });
        } else {
          event.preventDefault();
          item.setAttribute('open', '');

          // Get the height before it's visible
          dropdownWrapper.style.opacity = '0';
          dropdownWrapper.style.position = 'absolute';
          const wrapperHeight = dropdownWrapper.clientHeight;
          dropdownWrapper.style.opacity = '';
          dropdownWrapper.style.position = '';
          animate(0, wrapperHeight, duration, 'easeInOutQuad', (value) => {
            dropdownWrapper.style.height = `${value}px`;
          }).then(() => {
            dropdownWrapper.style.cssText = '';
          });
        }
      });
    });
  }

  // -------------
  // In view
  // https://github.com/camwiegert/in-view
  // -------------
  inView.threshold(0.5); // 50% of element must be visible to trigger

  // adds 'visible' class once when it becomes visible
  inView('.iv-once').on('enter', (el) => {
    el.classList.add('visible');
  });

  inView('.iv-once-children > *').on('enter', (el) => {
    el.classList.add('visible');
  });

  // adds 'visible' class when it becomes visible, then removes class when it stops being visible
  inView('.iv-repeat')
    .on('enter', (el) => {
      el.classList.add('visible');
    })
    .on('exit', (el) => {
      el.classList.remove('visible');
    });

  /**
   * Initialize browser/os specific styles
   */
  if (navigator.appVersion.indexOf('Win') !== -1)
    document.body.classList.add('os-windows');

  initPage();

  document.documentElement.style.setProperty(
    '--scrollbar-width',
    window.innerWidth - document.documentElement.clientWidth + 'px'
  );
});

document.addEventListener('scroll', function (e) {
  if (window.scrollY > 0) {
    document.querySelector('#main').classList.add('is-scrolled-off-top');
  } else {
    document.querySelector('#main').classList.remove('is-scrolled-off-top');
  }
  document
    .querySelector(':root')
    .style.setProperty(
      '--scroll-y',
      Math.round((window.scrollY / window.innerHeight) * 100)
    );
});

document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelector(':root')
    .style.setProperty(
      '--scroll-y',
      Math.round((window.scrollY / window.innerHeight) * 100)
    );
});

document.querySelectorAll('.block-link').forEach((el) => {
  el.addEventListener('click', function (e) {
    el.querySelector('a').click();
  });
});

// wrap all tables in page content in a responsive table container
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.page__main table').forEach((el) => {
    const wrapper = document.createElement('div');
    wrapper.classList.add('table-wrapper');
    el.parentNode.insertBefore(wrapper, el);
    wrapper.appendChild(el);
  });
});
